export default "__VITE_ASSET__D_RUUE3U__"